import { Text } from '@dixa/lib-shared-habla';

import { conversationDirectionAttributes } from 'utils/conversation';

import { useConversationRow } from '../../../utils/useConversationRow';

export const ConversationsTableDirection = (): JSX.Element => {
  const { conversation } = useConversationRow();
  const direction = conversation.initial_direction;

  return (
    <Text.Paragraph>
      {conversationDirectionAttributes[direction].label}
    </Text.Paragraph>
  );
};
